<script setup lang="ts">
import { StateOfUse } from './types.ts';
import { computed } from 'vue';
import { getColor } from './colors.ts';

const props = withDefaults(
  defineProps<{
    value?: StateOfUse;
    hideEnabled?: boolean;
  }>(),
  {
    value: undefined,
    hideEnabled: true,
  },
);

const show = computed(() => props.value && !(props.hideEnabled && props.value === 'Enabled'));
</script>

<template>
  <v-badge
    v-if="show"
    class="stateOfUseBadge"
    :color="getColor(value)"
    inline
    :content="$t(`StateOfUseEnum.${value}`)"
  />
</template>

<style scoped lang="scss">
:deep(.v-badge__badge) {
  border-radius: 4px;
}
</style>
